<template>
  <nav class="nav">
    <ul class="nav_list">
      <li class="nav_item" v-for="truck in truckData" :key="truck.id">
        <button class="nav_button" @click="handleClick(truck.category)">
          <span class="nav_button-title">{{ truck.category }}</span>
          <span class="nav_button-subtitle">{{ truck.subCategory }}</span>
        </button>
      </li>
    </ul>
    <svg
      class="nav_logo"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 430"
    >
      <path
        d="M332.7 167.5h61.9c-9-51.9-35-90.9-77.9-116.8-4.7 1.7-9.2 3.5-13.4 5.7-10.4 5.3-18.9 12.1-25.5 20.4-2 2.5-3.6 5.2-5 8 31.3 18.7 51.3 46.3 59.9 82.7zm59.7 94.8l-6.1-2.9h-54.1c-7.8 30.9-24 56.1-48.6 75.8-19 15.2-42.1 26.4-69.2 33.6 5.6 3.2 11.7 6.3 18.4 9.1 11.5 4.9 23.7 9 36.4 12.3l10.4 2.6c16.8-7.9 32.1-17.4 46.1-28.6 34.7-27.5 56.9-61.5 66.7-101.9zM1 84.9h57.8V352H1zm131.5 293.5H58.8v-.3H1v43.7h130.8c25.4 0 49.2-1.9 71.3-5.7v-44.7c-21.3 4.7-44.8 7-70.6 7z"
      />
      <path
        d="M137.3 11.8H1v43.8h57.8v-.3h77.1c30.5 0 57.6 2.7 81.2 8.1.8-1.2 1.5-2.4 2.4-3.5 9.6-13.6 22.1-25 37.3-34.1-33.8-9.4-73.6-14-119.5-14zm74.6 391.7v-56.6c7.8 5.7 17.2 10.9 28.1 15.4 10.9 4.6 22.4 8.4 34.4 11.6 12 3.1 24.1 5.6 36.3 7.3s23.4 2.6 33.7 2.6c35.6 0 62.1-5.5 79.7-16.4 17.6-11 26.3-26.7 26.3-47.3 0-11.1-2.9-20.7-8.8-28.9s-13.9-15.7-24.3-22.5c-10.3-6.8-22.5-13.2-36.7-19.4L335 229.7c-17.2-7.2-33.3-14.6-48.2-22C272 200.1 259 191.9 248 183c-11-9-19.7-19.1-26-30.5-6.3-11.3-9.5-24.6-9.5-39.9 0-18.7 4.9-34.9 14.8-48.8 9.9-13.8 22.8-25.2 38.9-34.2s34.4-15.6 54.9-20S362.6 3 383.9 3c48.7 0 84.1 4.9 106.4 14.6v54.1c-29.1-16.8-66.6-25.2-112.2-25.2-12.6 0-25.2 1.1-37.9 3.3-12.6 2.2-23.9 5.8-33.7 10.7-9.9 5-17.9 11.3-24.1 19.2-6.2 7.8-9.3 17.4-9.3 28.6 0 10.5 2.4 19.5 7.1 27.2 4.7 7.6 11.6 14.6 20.8 20.9s20.4 12.4 33.6 18.3 28.4 12.4 45.6 19.4c17.7 7.2 34.4 14.9 50.3 22.9 15.8 8 29.7 16.9 41.7 26.6 11.9 9.7 21.4 20.5 28.4 32.3s10.5 25.4 10.5 40.6c0 20.2-4.8 37.3-14.3 51.3s-22.4 25.4-38.6 34.2-34.8 15.1-55.9 19-43.4 5.9-66.8 5.9c-7.8 0-17.4-.5-28.9-1.6s-23.2-2.6-35.1-4.6-23.2-4.5-33.9-7.4-19.3-6.2-25.7-9.8z"
      />
    </svg>
  </nav>
</template>

<script>
export default {
  name: "AppNav",

  data() {
    return {
      truckData: [
        {
          id: 1,
          category: "ural / KRAZ",
          subCategory: "spare parts / trucks",
        },
        {
          id: 2,
          category: "kamaz / ZIL",
          subCategory: "spare parts / tyres",
        },
        {
          id: 3,
          category: "maz / GAZ / UAZ",
          subCategory: "spare parts / tyres",
        },
        {
          id: 4,
          category: "yamz",
          subCategory: "spare parts / engines",
        },
        // {
        //   id: 5,
        //   category: "armoured",
        //   subCategory: "vehicles / pare parts",
        // },
      ],
    };
  },

  methods: {
    handleClick(category) {
      this.$emit("click", category);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/function.scss";
@import "@/assets/breackpoints.scss";

.nav {
  position: relative;
  // position: absolute;
  /* bottom: vh(82px); */
  // bottom: 50%;
  // margin-bottom: -264px;
  // right: vw(55px);
  box-sizing: border-box;
  overflow: hidden;
  padding: vh(80px) vw(35px);
  width: 50%;
  height: 100%;
  background-color: rgba(#0e9244, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex-shrink: 0;
  margin-left: 10px;

  // @media (max-width: $osx) {
  //   padding: vh(70px) vw(35px);
  // }

  // @media (max-width: $xl) {
  //   width: 250px;
  // }

  // @media (max-height: 730px) {
  //   bottom: 1px;
  //   margin-bottom: 0;
  // }

  // @media (max-width: $lg) {
  //   width: 228px;
  //   bottom: 1px;
  //   margin-bottom: 0;
  //   padding: vh(60px) vw(35px);
  // }

  @media (max-width: $sm) {
    margin-left: 5px;
    height: 50%;
    width: 100%;
    margin-top: 5px;
    //   position: relative;
    //   // height: calc(100% - 2px);
    //   height: 100%;
    //   /* min-height: 400px; */
    //   bottom: auto;
    //   right: auto;
    //   width: 100%;
    //   margin-bottom: 2px;
    //   box-sizing: border-box;
    //   padding: vh(30px) vw(55px);
  }

  &_list {
    position: relative;
    margin: 0;
    padding: 0;
    text-indent: 0;
    list-style: none;
    list-style-position: outside;
    z-index: 1;

    @media (max-width: $sm) {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }
  }

  &_item {
    @media (max-width: $sm) {
      width: 205px;
    }

    &:not(:last-of-type) {
      margin-bottom: vh(35px);

      @media (max-width: $lg) {
        margin-bottom: vh(25px);
      }

      @media (max-width: $sm) {
        margin-bottom: vh(40px);
      }
    }
  }

  &_button {
    position: relative;
    display: flex;
    flex-direction: column;
    padding-left: 15px;
    background-color: transparent;

    &:hover,
    &:focus {
      &::before {
        left: 10px;
      }

      .nav_button-subtitle {
        color: rgba(#ffffff, 0.7);
      }
    }

    &::before {
      content: "";
      position: absolute;
      top: 4px;
      left: 0;
      width: 2px;
      height: 25px;
      background-color: #ffffff;
      transition: all 0.25s ease;
    }
  }

  &_button-title {
    font-size: 24px;
    font-weight: 800;
    color: #ffffff;
    text-transform: uppercase;
    line-height: 1;
    text-align: left;
    white-space: pre-wrap;

    @media (max-width: $lg) {
      font-size: 24px;
    }

    @media (max-width: $sm) {
      font-size: 20px;
    }
  }

  &_button-subtitle {
    font-size: 11px;
    font-weight: 300;
    color: #ffffff;
    transition: all 0.25s ease;
    text-transform: uppercase;

    @media (max-width: $lg) {
      font-size: 12px;
    }

    @media (max-width: $sm) {
      font-size: 10px;
    }
  }

  &_logo {
    position: absolute;
    fill: rgba(#1a5936, 0.5);
    width: 480px;
    top: -10px;
    left: 50%;
    z-index: 0;
    transform: translateX(-60%);

    @media (max-width: $sm) {
      width: 380px;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

.nav_list-new {
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 15px;
  position: relative;
  color: #ffffff;
  font-weight: 700;
  z-index: 1;
  margin-bottom: -20px;

  @media (max-width: $sm) {
    margin-bottom: 0;
  }
}
</style>
